export function useAnonymousInfo() {
  const anonymousInfoStore = useAnonymousStore()

  return {
    anonymousId: anonymousInfoStore.anonymousId,
    ensureAnonymousId: anonymousInfoStore.ensureAnonymousId,
  }
}
